import type { FieldValues, UseFormReturn } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

/**
 * Hook that safely attempts to use form context.
 * Always called at the top level to comply with React Hooks rules.
 * Returns null if FormProvider is not available.
 */
export function useOptionalFormContext<T extends FieldValues>(): UseFormReturn<T> | null {
  try {
    return useFormContext<T>();
  } catch {
    // Not inside FormProvider - return null
    return null;
  }
}
